<template>
  <div class="form-group">
    <label> {{ label }} </label>
    <br />
    <span class="detail-text text-muted">
      <slot name="content">
        {{ text !== null ? text : "-" }}
      </slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    renderText() {
      if (this.text !== null) {
        if (this.text === "undefined null") return "-";
        else return this.text;
      }

      return "-";
    },
  },
};
</script>

<style></style>
